import type {
  AuthTokenCreationQuery,
  RecoverPasswordCreationQuery,
  Refresh2FactorCodeQuery,
  Send2FactorValidationQuery,
} from "@/Modules/Models/Domain/Auth";
import type {
  AuthTokenApi,
  AuthTokenApiCreationQuery,
  RecoverPasswordApiCreationQuery,
  ResetPasswordApiCreationQuery,
  VerifyTokenResponse,
  VefifyTokenQuery,
  RefreshTokenApi,
  RefreshTokenQuery,
} from "@/Modules/Models/Api/Auth";

import { post2, patch2 } from "./utils/FunctionalTherapyApi";
import { isValidString } from "@/Utils/String";

let isLogoutProcess = false;

export const verifyToken = (token: string): Promise<VerifyTokenResponse> => {
  return post2<VefifyTokenQuery, VerifyTokenResponse>("/v1.0/auth/verify", { token });
};

export const login = (authTokenCreationQuery: AuthTokenCreationQuery): Promise<AuthTokenApi> => {
  return post2<AuthTokenApiCreationQuery, AuthTokenApi>("/v2.0/users/login", authTokenCreationQuery);
};

export const send2FCode = async (query: Send2FactorValidationQuery): Promise<AuthTokenApi> => {
  return post2<Send2FactorValidationQuery, AuthTokenApi>("/v1.0/auth/two-factor", query);
};

export const refreshCode2Factor = async (
  query: Refresh2FactorCodeQuery
): Promise<Pick<AuthTokenApi, "hash_2F">> => {
  return patch2<Refresh2FactorCodeQuery, AuthTokenApi>("/v1.0/auth/two-factor", query);
};

export const logout = async (forcedToken?: string): Promise<void> => {
  if (!isLogoutProcess) {
    isLogoutProcess = true;

    if (isValidString(forcedToken)) {
      return post2<void, void>("v1.0/users/logout", undefined, { Authorization: `Bearer ${forcedToken}` });
    } else {
      return post2<void, void>("v1.0/users/logout");
    }
  }

  return Promise.resolve();
};

export const recoverPassword = async (
  recoverPasswordApiCreationQuery: RecoverPasswordApiCreationQuery
): Promise<void> => {
  await post2<RecoverPasswordCreationQuery, void>(
    "/v1.0/passwords/recovery",
    recoverPasswordApiCreationQuery
  );
};

export const resetPassword = async (
  resetPasswordApiCreationQuery: ResetPasswordApiCreationQuery
): Promise<void> => {
  await post2<ResetPasswordApiCreationQuery, void>("/v1.0/passwords/reset", resetPasswordApiCreationQuery);
};

export const refreshToken = async (token: string): Promise<RefreshTokenApi> => {
  return post2<RefreshTokenQuery, RefreshTokenApi>("/v1.0/auth/refresh", { token });
};
